module.exports = __webpack_public_path__ + "img/arrow_down.b39afa8d.svg";